import { renderValue } from './renderValue';

type CompositeColumnProps = {
  column: DynamicColumnType;
  data: Record<string, any>;
};

type ColumnRowProps = {
  value: unknown;
  data: Record<string, any>;
  field: DynamicColumnCompositeSubFieldType;
};

const ColumnRow: React.FC<ColumnRowProps> = ({ value, data, field }) => {
  const suffix = field.renderSuffix?.(value, data);

  return (
    <div style={field.style || {}}>
      {renderValue(value, field.format)}
      {suffix}
    </div>
  );
};

export const CompositeColumn: React.FC<CompositeColumnProps> = ({
  column,
  data,
}) => {
  return (
    <div>
      {column.fields?.map?.((field, index) => (
        <ColumnRow
          data={data}
          field={field}
          value={data?.[field.key]}
          key={`${field.key}_${field.id || index}`}
        />
      ))}
    </div>
  );
};
